import api from './api.service';

/**
 * Catalogue de capacités servi par l'API (saas/12, §4).
 * AUCUNE liste de capacités en dur côté front : les noms et états viennent
 * exclusivement de GET /api/me/capabilities.
 * - granted     : accordée par le plan → écran actif.
 * - unlockable  : vendue par un plan achetable → visible et désactivée,
 *                 avec l'appel à l'action vers Stripe (l'écran verrouillé
 *                 EST l'argumentaire).
 * - unavailable : aucun plan ne la vend → masquée.
 */
export type CapabilityState = 'granted' | 'unlockable' | 'unavailable';

export interface CapabilitiesResponse {
  capabilities: Record<string, CapabilityState>;
  tier: string | null;
  publishedCount: number;
  publishedQuota: number | null; // null = illimité
  emailVerified: boolean;
}

export const capabilitiesService = {
  async getCapabilities(): Promise<CapabilitiesResponse> {
    const res = await api.get('/me/capabilities');
    return res.data;
  },
};
